<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

    <main class="container py-4">

        <!-- TOP BAR -->
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
                <div class="text-muted small">Wallet</div>
                <h4 class="mb-0 fw-bold">Details</h4>
            </div>

            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary btn-sm" (click)="back()">Back</button>
                <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="loadWallet()">
                    <span *ngIf="!loading">Refresh</span>
                    <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
                </button>
                <button class="btn btn-primary btn-sm" [disabled]="loading || !wallet" (click)="deposit()">
                    Deposit
                </button>
            </div>
        </div>

        <!-- ERROR -->
        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

        <!-- LOADING SKELETON -->
        <div *ngIf="loading && !wallet" class="card shadow-sm border-0">
            <div class="card-body p-4">
                <div class="placeholder-glow">
                    <div class="placeholder col-4 mb-2"></div>
                    <div class="placeholder col-7 mb-4"></div>
                    <div class="placeholder col-12 mb-2"></div>
                    <div class="placeholder col-10 mb-2"></div>
                    <div class="placeholder col-8"></div>
                </div>
            </div>
        </div>

        <!-- WALLET CONTENT -->
        <ng-container *ngIf="wallet as w">
            <div class="row g-3">
                <!-- SUMMARY CARD -->
                <div class="col-12 col-lg-5">
                    <div class="card shadow-sm border-0 h-100">
                        <div class="card-body p-4">
                            <div class="d-flex align-items-start justify-content-between">
                                <div>
                                    <div class="text-muted small">Currency</div>
                                    <div class="d-flex align-items-center gap-2">
                                        <div class="fw-bold fs-5">{{ w.currency.name }} ({{ w.currency.code }})</div>
                                        <span class="badge" [class.text-bg-success]="w.status === 'Active'"
                                            [class.text-bg-secondary]="w.status !== 'Active'">
                                            {{ w.status }}
                                        </span>
                                    </div>
                                    <div class="text-muted small mt-1">Wallet ID</div>
                                    <div class="small font-monospace">{{ w.walletId }}</div>
                                </div>
                            </div>

                            <hr class="my-3">

                            <div class="row g-3">
                                <div class="col-12">
                                    <div class="text-muted small">Available Balance</div>
                                    <div class="fw-bold fs-3">
                                        {{ w.availableBalance || 0 | smartAmount:w.currency.symbol }}
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="text-muted small">Balance</div>
                                    <div class="fw-semibold fs-5">
                                        {{ w.balance || 0 | smartAmount:w.currency.symbol }}
                                    </div>
                                </div>
                            </div>

                            <hr class="my-3">

                            <div class="small text-muted">
                                Created: {{ w.createdAt | date:'medium' }} <br />
                                Updated: {{ w.lastUpdatedAt | date:'medium' }}
                            </div>

                            <div class="d-flex gap-2 mt-3">
                                <button class="btn btn-primary w-100" (click)="back()">All Wallets</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ACTIVITY / PLACEHOLDERS -->
                <div class="col-12 col-lg-7">
                    <div class="card shadow-sm border-0 mb-3">
                        <div class="card-body p-4">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <div class="fw-bold">Quick Actions</div>
                                    <div class="text-muted small">Common wallet operations</div>
                                </div>
                            </div>

                            <div class="row g-2 mt-2">
                                <div class="col-12 col-md-6">
                                    <button class="btn btn-outline-primary w-100" (click)="deposit()">Deposit</button>
                                </div>
                                <div class="col-12 col-md-6"> 
                                    <button class="btn btn-outline-primary w-100" (click)="withdraw()">Withdraw</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Ledger / Holds placeholders (since WalletDetailsDto currently doesn't include arrays) -->
                    <div class="card shadow-sm border-0 mt-4">
                        <div class="card-body p-0">

                            <!-- HEADER -->
                            <div class="p-3 border-bottom">
                                <div class="fw-bold">Recent Activity</div>
                                <div class="text-muted small">Deposits, withdrawals, orders & activity log</div>
                            </div>

                            <!-- TABS -->
                            <ul class="nav nav-tabs px-3 pt-3" role="tablist">
                                <li class="nav-item">
                                    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#depositsTab"
                                        type="button">
                                        Deposits
                                    </button>
                                </li>

                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#withdrawalsTab"
                                        type="button">
                                        Withdrawals
                                    </button>
                                </li>

                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#ordersTab"
                                        type="button">
                                        Orders
                                    </button>
                                </li>

                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#settlementTab"
                                        type="button">
                                        Settlement
                                    </button>
                                </li>

                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#activitiesTab"
                                        type="button">
                                        Activities
                                    </button>
                                </li>
                            </ul>

                            <!-- TAB CONTENT -->
                            <div class="tab-content p-3">
                                <!-- DEPOSITS -->
                                <div class="tab-pane fade show active" id="depositsTab">

                                <div
                                    class="d-flex justify-content-between align-items-center py-2 border-bottom"
                                    *ngFor="let deposit of walletDeposits">

                                    <div>
                                    <button
                                        class="btn btn-link btn-sm p-0 text-decoration-none fw-semibold"
                                        type="button"
                                        (click)="openDepositDetails(deposit)">
                                        {{ deposit?.depositId }}
                                    </button>

                                    <div class="text-muted small">
                                        {{ deposit?.createdAt | date: 'MMM d, y • h:mm a' }}
                                    </div>

                                    <a
                                        *ngIf="deposit?.status === 'Pending'"
                                        class="btn btn-sm btn-outline-primary ms-2"
                                        (click)="confirmDeposit(deposit.depositId)">
                                        Confirm Pending
                                    </a>
                                    </div>

                                    <div class="text-end">
                                    <div class="fw-bold text-success">
                                        {{ deposit?.amount | smartAmount:deposit.currency.symbol }}
                                    </div>
                                    <div [class]="getDepositAndWithdrawalStatusClass(deposit.status)">
                                        {{ deposit?.status | titlecase }}
                                    </div>
                                    </div>
                                </div>

                                <div
                                    *ngIf="walletDeposits?.length === 0"
                                    class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                    <i class="bi bi-inbox fs-1 mb-3"></i>
                                    <div class="fw-semibold">No deposits yet</div>
                                    <div class="small">Your completed deposits will appear here.</div>
                                </div>

                                <div *ngIf="(walletDeposits?.length || 0) > 1" class="text-center mt-3">
                                    <a
                                    class="btn btn-outline-secondary btn-sm"
                                    [routerLink]="['/wallets/deposit/history']"
                                    [queryParams]="{ walletId: walletId }">
                                    View Full Deposit History
                                    </a>
                                </div>
                                </div>

                                <!-- WITHDRAWALS -->
                                <div class="tab-pane fade" id="withdrawalsTab">

                                    <div 
                                        class="d-flex justify-content-between align-items-center py-2 border-bottom" 
                                        *ngFor="let withdrawal of walletWithdrawals">

                                        <div>
                                            <button
                                            class="btn btn-link btn-sm p-0 text-decoration-none fw-semibold"
                                            type="button"
                                            (click)="openWithdrawalDetails(withdrawal)">
                                                {{ withdrawal?.withdrawalId }}
                                            </button>
                                            <div class="text-muted small">
                                                {{withdrawal?.createdAt | date: 'MMM d, y • h:mm a'}}
                                            </div>

                                            <a *ngIf="withdrawal?.status === 'Pending'"
                                            class="btn btn-sm btn-outline-primary ms-2"
                                            (click)="confirmWithdrawal(withdrawal.withdrawalId)">
                                                Confirm Pending
                                            </a>
                                        </div>

                                        <div class="text-end">
                                            <div class="fw-bold text-success">
                                                {{ withdrawal?.amount | smartAmount:withdrawal.currency.symbol }}
                                            </div>
                                            <div [class]="getDepositAndWithdrawalStatusClass(withdrawal.status)">
                                                {{ withdrawal?.status | titlecase }}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- EMPTY STATE -->
                                    <div *ngIf="walletWithdrawals?.length === 0" 
                                        class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                        <i class="bi bi-inbox fs-1 mb-3"></i>
                                        <div class="fw-semibold">No withdrawals yet</div>
                                        <div class="small">Your completed withdrawals will appear here.</div>
                                    </div>

                                    <!-- VIEW ALL BUTTON -->
                                    <div *ngIf="(walletWithdrawals?.length || 0) > 1" class="text-center mt-3">
                                        <a 
                                            class="btn btn-outline-secondary btn-sm"
                                            [routerLink]="['/wallets/withdraw/history']"
                                            [queryParams]="{ walletId: walletId }">
                                            View Full Withdrawal History
                                        </a>
                                    </div>

                                </div>

                                <!-- ORDERS -->
                                <div class="tab-pane fade" id="ordersTab">
                                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom" *ngFor="let order of walletOrders">
                                        <div>
                                            <div class="fw-semibold"><a [routerLink]="['/orders/manage', order.id, 'wallets', w.walletId]">{{order?.id}}</a></div>
                                            <div class="text-muted small">{{order?.fromCurrency?.code + " → " + order?.toCurrency?.code}}</div>
                                        </div>
                                        <div class="text-end">
                                            <div class="fw-bold">{{ order?.originalAmount | smartAmount:order.fromCurrency.symbol }} @ {{order?.rate}}</div>
                                            <div [class]="getOrderStatusClass(order.status)" >{{ order?.status | titlecase }}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="walletOrders?.length === 0" 
                                        class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                        <i class="bi bi-inbox fs-1 mb-3"></i>
                                        <div class="fw-semibold">No orders yet</div>
                                        <div class="small">Your completed orders will appear here.</div>
                                    </div>
                                </div>

                                <!-- SETTLEMENT -->
                                <div class="tab-pane fade" id="settlementTab">
                                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom" *ngFor="let settlement of walletSettlements">
                                        <div>
                                            <div class="fw-semibold">{{settlement?.settlementId}}</div>
                                            <div class="text-muted small">Ctreated at: {{settlement?.createdAt | date: 'medium'}}</div>
                                            <div class="text-muted small">Settled at: {{settlement?.settledAt | date: 'medium'}}</div>
                                        </div>
                                        <div class="text-end">
                                            <div class="fw-bold">{{ settlement?.netAmount | smartAmount:settlement.currency }}</div>
                                            <div [class]="getSettlementStatusClass(settlement.status)" >{{ settlement?.status | titlecase }}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="walletSettlements?.length === 0" 
                                        class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                        <i class="bi bi-inbox fs-1 mb-3"></i>
                                        <div class="fw-semibold">No settlements yet</div>
                                        <div class="small">Your completed settlements will appear here.</div>
                                    </div>
                                </div>

                                <!-- ACTIVITIES -->
                                <div class="tab-pane fade" id="activitiesTab">
                                    <div class="py-2 border-bottom">
                                        <div class="fw-semibold">Deposit Confirmed</div>
                                        <div class="text-muted small">Mar 18, 2026 • 10:45 AM</div>
                                        <div class="small">Bank transfer successfully processed.</div>
                                    </div>

                                    <div class="py-2 border-bottom">
                                        <div class="fw-semibold">Hold Created</div>
                                        <div class="text-muted small">Mar 13, 2026 • 11:20 AM</div>
                                        <div class="small">Funds reserved for Buy USD order.</div>
                                    </div>
                                    <div *ngIf="walletTrades?.length === 0" 
                                        class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                        <i class="bi bi-inbox fs-1 mb-3"></i>
                                        <div class="fw-semibold">No transactions yet</div>
                                        <div class="small">Your completed transactions will appear here.</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </ng-container>

        <app-footer></app-footer>
    </main>
</div>
<app-withdrawal-details-modal
  [(visible)]="showWithdrawalDetailsModal"
  [withdrawal]="selectedWithdrawal">
</app-withdrawal-details-modal>
<app-deposit-details-modal
  [(visible)]="showDepositDetailsModal"
  [deposit]="selectedDeposit">
</app-deposit-details-modal>